
import Vue from 'vue'
import { Category as SidebarCategory } from '@/model/category'
import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'

import TopSearchControl from '@/common/components/TopSearchControl.vue'

export default Vue.extend({
  name: 'SidebarProductSearch',
  components: {
    TopSearchControl
  },
  props: {
    rootCategory: {
      type: Object as () => SidebarCategory,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  }
})
